import type { DetailedPageSegmentLoadSlo, Slo } from './types';

export const isDetailedPageSegmentLoadSlo = (
	data: DetailedPageSegmentLoadSlo | Slo,
): data is DetailedPageSegmentLoadSlo => {
	return Boolean((data as DetailedPageSegmentLoadSlo).initial);
};
